import classNames from 'classnames';
import { forwardRef } from 'react';

interface IconButtonProps {
  id?: string;
  className?: string;
  e2e?: string;
  iconName: string;
  isDisabled?: boolean;
  onClick?: () => void;
  title?: string;
  ariaLabel?: string;
  variant?: 'filled' | 'outlined';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ id, iconName, onClick, title, isDisabled, className, e2e, ariaLabel, variant = 'filled' }, ref) => (
    <button
      id={id}
      ref={ref}
      title={title}
      className={classNames('btn btn-icon btn-flat-secondary', className)}
      data-e2e={e2e}
      disabled={isDisabled}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <i className={classNames('icon', { 'icon-outlined': variant === 'outlined' })} aria-hidden={!!ariaLabel}>
        {iconName}
      </i>
    </button>
  ),
);

IconButton.displayName = 'IconButton';
